import { type ReactNode } from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

type ContainerProps = {
    children: ReactNode;
};

type HeaderProps = {
    title: ReactNode;
    button?: {
        onClick: () => void;
        label: ReactNode;
        variant?: "text" | "outlined" | "contained";
        color?:
            | "primary"
            | "secondary"
            | "error"
            | "warning"
            | "info"
            | "success";
        disabled?: boolean;
    };
};

type MainProps = {
    children: ReactNode;
};

export const styled = {
    Container({ children }: ContainerProps) {
        return (
            <Container component={"section"} maxWidth="md">
                <Stack spacing={4}>{children}</Stack>
            </Container>
        );
    },

    Header({ title, button }: HeaderProps) {
        return (
            <Box component={"header"} sx={{ pt: 1 }}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h1" data-testid="template-title">
                        {title}
                    </Typography>
                    {button && (
                        <Button
                            variant={button.variant || "contained"}
                            color={button.color || "primary"}
                            size="large"
                            onClick={button.onClick}
                            disabled={button.disabled}
                            data-testid="template-action-button"
                        >
                            {button.label}
                        </Button>
                    )}
                </Stack>
            </Box>
        );
    },

    Main({ children }: MainProps) {
        return (
            <Stack component="main" direction="column" spacing={0}>
                {children}
            </Stack>
        );
    },
};
